import { render } from "./top-height-view.vue?vue&type=template&id=f203453e"
import script from "./top-height-view.vue?vue&type=script&lang=ts"
export * from "./top-height-view.vue?vue&type=script&lang=ts"

import "./top-height-view.vue?vue&type=style&index=0&id=f203453e&lang=less"
script.render = render

export default script